// extracted by mini-css-extract-plugin
module.exports = {"TeamCard":"TeamCard_TeamCard__2RhXz","img-container":"TeamCard_img-container__3IZsm","bottom":"TeamCard_bottom__1YnAF","top":"TeamCard_top__1grhc"};